// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group {
  display: flex;
  align-items: center;
}

button {
  border: none;
}

.scrollable-content {
  max-height: 100vh;
  overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./projects/eCash/src/app/reports/detailed-report-grid/detailed-report-grid.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;AACJ;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,iBAAA;EACA,gBAAA;AACJ","sourcesContent":[".form-group {\n    display: flex;\n    align-items: center;\n}\n\nbutton {\n    border: none;\n}\n\n.scrollable-content {\n    max-height: 100vh;\n    overflow-y: auto;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
